import React, { Fragment, useEffect, useRef, useState } from 'react';
import { UIStateProps, uiState } from '../../atoms/uiAtom';

import classNames from 'classnames';
import { useRecoilValue } from 'recoil';

export interface BottomFixedContainerProps {
  children?: React.ReactNode;
  ref?: React.RefObject<HTMLDivElement>;
  height?: number | string;
  className?: string;
  fixedBottomElementClassName?: string;
  tag?: string;
  fixedBottomElement?: React.ReactNode;
}
export default function Container({
  tag = 'div',
  height,
  children,
  className,
  fixedBottomElementClassName,
  fixedBottomElement,
}: BottomFixedContainerProps) {
  const ui = useRecoilValue<UIStateProps>(uiState);
  const [fixedBottomElementRefHeight, setFixedBottomElementRefHeight] = useState(0);
  const [containerElementRefWidth, setContainerElementRefWidth] = useState(0);
  const fixedBottomElementRef = useRef(null);
  const containerElementRef = useRef(null);

  useEffect(() => {
    if (containerElementRef && containerElementRef.current) {
      setContainerElementRefWidth((containerElementRef.current as any).offsetWidth);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (containerElementRef.current as any)?.offsetWidth,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (containerElementRef.current as any)?.clientWidth,
    fixedBottomElementClassName,
  ]);

  useEffect(() => {
    if (fixedBottomElementRef && fixedBottomElementRef.current) {
      setFixedBottomElementRefHeight((fixedBottomElementRef.current as any).clientHeight);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [(fixedBottomElementRef?.current as any)?.clientHeight]);

  const calculateMainHeight = () => {
    if (ui.hasError || ui.hasWarning) {
      return `calc(100vh - ${136 + fixedBottomElementRefHeight}px)`;
    } else if (ui.hasError && ui.hasWarning) {
      return `calc(100vh - ${192 + fixedBottomElementRefHeight}px)`;
    } else {
      return `calc(100vh - ${80 + fixedBottomElementRefHeight}px)`;
    }
  };
  const CustomTag = tag as any;
  return (
    <Fragment>
      <CustomTag
        ref={containerElementRef}
        style={{
          height: height ?? calculateMainHeight(),
          overflowY: 'auto',
        }}
        className={classNames('custom-container', className)}
      >
        {children}
      </CustomTag>
      {fixedBottomElement && containerElementRefWidth && (
        <div
          ref={fixedBottomElementRef}
          style={{
            width: !fixedBottomElementClassName?.includes('--collapsed')
              ? containerElementRefWidth + 5
              : 'auto',
          }}
          className={classNames('custom-container__bottom-element', fixedBottomElementClassName)}
        >
          {fixedBottomElement}
        </div>
      )}
    </Fragment>
  );
}
